export const jpmuidDefault = {
  anon: "99999999-9999-9999-9999-999999999999",
  bot: "00000000-0000-0000-0000-000000000000",
}
